import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {
    s_char_bloodmagicitems,
} from "../_signals/s_char";

import {ICharBloodMagicItem} from "../_interfaces/ICharBloodMagicItem";

export const BloodMagicItemsGet = (cid: string) => {
    fetch(apiAddress + "/char/bloodmagicitems/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BEBloodMagicItems get reponse', data.result);
                    s_char_bloodmagicitems.value = (data.result as ICharBloodMagicItem[])
                }
            }
        )
        .catch((reason => {
            console.log('BEBloodMagic get catch', reason);
        }))
}

export const BloodMagicItemCreate = (bloodmagic: ICharBloodMagicItem) => {
    fetch(apiAddress + "/char/bloodmagicitems/", createOptions('CREATE', bloodmagic))
        .then((res) => res.json())
        .then((data) => console.log('BEBloodMagicItem create reponse', data))
        .catch((reason => console.log('BEBloodMagicItem create catch', reason)))
}

export const BloodMagicItemUpdate = (bloodmagic: ICharBloodMagicItem) => {
    fetch(apiAddress + "/char/bloodmagicitems/", createOptions('UPDATE', bloodmagic))
        .then((res) => res.json())
        .then((data) => console.log('BEBloodMagicItem update repsonse', data))
        .catch((reason => console.log('BEBloodMagicItem update catch', reason)))
}

export const BloodMagicItemDelete = (bloodmagic: ICharBloodMagicItem) => {
    fetch(apiAddress + "/char/bloodmagicitems/", createOptions('DELETE', bloodmagic))
        .then((res) => res.json())
        .then((data) => console.log('BEBloodMagicItem delete repsonse', data))
        .catch((reason => console.log('BEBloodMagicItem delete catch', reason)))
}
